export enum UserAvatarType {
  Solid = "Solid",
  Outlined = "Outlined",
  Dimmed = "Dimmed",
}

export enum UserAvatarAltType {
  Group = "Group",
  Organisation = "Organisation",
}
